import React from 'react';
import { connectStats } from 'react-instantsearch-dom';
import { Typography } from 'ck-ui';
import PropTypes from 'prop-types';
import styles from './NbHits.module.scss';

const Stats = ({ nbHits, isMobile }) => {
  const totalHits = Number(nbHits) || 0;

  if (isMobile) {
    return (
      <span className={styles.mobileText}>
        ({totalHits} items)
      </span>
    );
  }
  return (
    <div className={styles.center}>
      <Typography color="black-bis" variant="body-large" weight={500}>
        {totalHits}
      </Typography> &nbsp;
      <Typography variant="body-large">
        items found
      </Typography>
    </div>
  );
};

Stats.propTypes = {
  nbHits: PropTypes.number.isRequired,
  isMobile: PropTypes.bool
};

Stats.defaultProps = {
  isMobile: false
};

export const NbHits = connectStats(Stats);
